<template>
  <IconLucideCircleEllipsis />
</template>
